const BASE_URL = process.env.BASE_URL || "/";
const wowzaApi = process.env.VUE_APP_STREAMING_SERVER || "/";
const fileServer = process.env.VUE_APP_FILE_SERVER || "/";
const streamServer = process.env.VUE_APP_VDO_STREAMING_SERVER || "/";
import {getECode, getRStage} from "@/utils/auth-data";


export const config = {
  fileExtension: {
    csv: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    video: 'video/*',
    images: 'image/*',
    document: 'image/*,' +
      ' .csv,' +
      ' application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
      ' application/vnd.ms-excel,' +
      ' .doc,' +
      ' .docx,' +
      ' .pdf,' +
      ' application/vnd.ms-powerpoint,' +
      ' application/mspowerpoint,' +
      ' application/x-mspowerpoint,' +
      ' application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  url: {
    vdoOnDemandApi: `${wowzaApi}/video-upload`,
    vdoIntroductionApi: `${wowzaApi}/video-upload`,
    vdoMaterialApi: `${wowzaApi}/upload-vdo-material`,
    liveVdoApi: `${wowzaApi}upload-vdo-live-set`,
    uploadFiles: `${fileServer}/upload`,
    uploadAvatar: `${fileServer}/upload`,
    downloadFile: `${fileServer}/${getECode}/${getRStage}/`,

    noAvatarImage: BASE_URL + 'static/images/no-avatar.png',
    noPhotoImage: BASE_URL + 'static/images/NoPhotoAvailable.jpg',
    downloadVideo: `${fileServer}/video`,
  },
  prefixFileName: {
    vdoOnDemand: 'ODM',
    vdoIntroduction: 'VID',
    vdoLiveSet: 'VLS'
  },
  operationName:{
    teacherAvatar: 'image-upload',
    studentAvatar: 'image-upload',
    classAssignment: 'document-upload',
    classMaterial: 'document-upload',
    courseOutline: 'image-upload',
  },
  baseUrl: BASE_URL,
  streamServer: streamServer,
};

export function getAvatarUrl(picturePath){
  if(picturePath){
    return config.url.downloadFile  + picturePath;
  }else{
    return BASE_URL + 'static/images/no-avatar.png'
  }
}

export function getPhotoUrl(picturePath){
  if(picturePath){
    return config.url.downloadFile  + picturePath;
  }else{
    return BASE_URL + 'static/images/NoPhotoAvailable.jpg'
  }
}



export function getClassRoomUrl(picturePath){
  if(picturePath){
    return config.url.downloadFile  + picturePath;
  }else{
    return BASE_URL + 'static/images/classroom-placeholder.jpg'
  }
}


